<template>
  <div>
    <div class="d-flex mb-5 align-center justify-space-between">
      <div>
        <div class="titulo-pagina">
          {{ tituloFormulario }}
        </div>
        <div v-if="form.id">
          <v-chip class="mr-1" small>
            {{ $t('modulos.formula.formulario.codigoTag') + `${form.codigo}` }}
          </v-chip>
        </div>
      </div>
      <botao-padrao v-if="form.revisoes.length" outline disabled>
        {{ revisao }}
      </botao-padrao>
    </div>
    <v-tabs
      v-model="indiceAba"
      class="abas-padrao"
      background-color="primary"
      color="primary"
    >
      <v-tab>
        {{ $t('modulos.formula.formulario.abas.dados_formula') }}
      </v-tab>
      <v-tooltip v-if="!form.id" top>
        <template v-slot:activator="{ on, attrs }">
          <div
            class="v-tab"
            v-bind="attrs"
            v-on="!form.id ? on : null"
            @click="salvarClickAba"
          >
            <div class="v-tab" v-bind="attrs" v-on="!form.id ? on : null">
              {{ $t('modulos.formula.formulario.abas.formulas_derivadas') }}
            </div>
          </div>
        </template>
        <span>
          {{ $t('modulos.formula.formulario.abas.clique_salvar_dados') }}
        </span>
      </v-tooltip>

      <v-tab v-else>
        {{ $t('modulos.formula.formulario.abas.formulas_derivadas') }}
      </v-tab>
      <!-- <v-tab>
        {{ $t('modulos.formula.formulario.abas.formulas_derivadas') }}
      </v-tab> -->
    </v-tabs>
    <v-tabs-items v-model="indiceAba">
      <v-tab-item>
        <dados-formula
          ref="dados-formula"
          :form="form"
          :revisao-formula-id="idRevisao"
        />
      </v-tab-item>
      <v-tab-item>
        <formulas-derivadas
          ref="formulas-derivadas"
          :form="form"
          :revisao-formula-id="idRevisao"
          @dados-alterados="atualizarDadosFormula"
        />
      </v-tab-item>
    </v-tabs-items>
    <v-divider class="my-5" />
    <div class="d-flex align-center justify-end">
      <botao-padrao
        v-if="form.flagSistema || visualizar"
        outlined
        color="secondary"
        class="mr-2"
        @click="voltar"
      >
        <v-icon>$mdiArrowLeft</v-icon>
        {{ $t('geral.botoes.voltar') }}
      </botao-padrao>

      <template v-else>
        <botao-padrao outlined color="secondary" class="mr-2" @click="cancelar">
          <v-icon>$mdiCancel</v-icon>
          {{ $t('geral.botoes.cancelar') }}
        </botao-padrao>
        <botao-padrao
          v-if="!form.flagSistema && !form.id"
          class="mr-2"
          @click="confirmacaoSalvar('sair')"
        >
          <v-icon>$mdiContentSaveOutline</v-icon>
          {{ $t('geral.botoes.salvar') }}
        </botao-padrao>
        <botao-padrao
          v-if="!form.flagSistema && form.id"
          class="mr-2"
          @click="confirmacaoSalvar('continuar')"
        >
          <v-icon>$mdiContentSaveOutline</v-icon>
          {{ $t('geral.botoes.salvarContinuar') }}
        </botao-padrao>
        <botao-padrao
          v-if="!form.flagSistema && form.id"
          class="mr-2"
          @click="confirmacaoSalvar('sair')"
        >
          <v-icon>$mdiContentSaveOutline</v-icon>
          {{ $t('geral.botoes.salvarSair') }}
        </botao-padrao>
        <botao-padrao
          v-if="!form.flagSistema && form.id"
          sem-capitalize
          @click="verificarPublicacaoFormula"
        >
          <v-icon>$mdiPublish</v-icon>
          {{ $t('geral.botoes.publicar') }}
        </botao-padrao>
      </template>
    </div>
  </div>
</template>
<script>
import helpers from '@common/utils/helpers';
import FormulaService from '@common/services/cadastros/FormulaService.js';
import { FormulaModel } from '@common/models/cadastros/FormulaModel.js';
import { FormulaTabelaModel } from '@common/models/cadastros/FormulaTabelaModel.js';
import DadosFormula from './components/DadosFormula.vue';
import FormulasDerivadas from './components/FormulasDerivadas.vue';

export default {
  components: {
    DadosFormula,
    FormulasDerivadas,
  },
  props: {
    id: { type: String, default: null },
    idRevisao: { type: String, default: '' },
    idFormulaFilha: { type: String, default: null },
  },
  data() {
    return {
      visualizar: false,
      flagSistema: 'Sim',
      tabelaValida: false,
      indiceAba: 0,
      valido: false,
      form: new FormulaModel({}),
      dados: [],
    };
  },
  computed: {
    tituloFormulario() {
      if (this.visualizar) return this.$t('modulos.formula.titulos.visualizar');
      if (this.id) return this.$t('modulos.formula.titulos.editar');
      return this.$t('modulos.formula.titulos.novo');
    },
    tooltipBotaoSalvar() {
      if (this.valido) return '';
      return this.$t('modulos.formula.validacoes.formulario_invalido');
    },
    revisao() {
      const revisao = this.form.revisoes.length - 1;

      return `${this.$t('modulos.formula.titulos.revisao')}: ${revisao}`;
    },
  },
  watch: {
    id() {
      if (this.id) this.buscar();
      this.$store.dispatch('Layout/alterarTituloPagina', this.tituloFormulario);
    },
  },
  mounted() {
    if (this.$route.name == 'formula-visualizar') {
      this.buscar();
      helpers.redirecionarSemPermissao(this, 'Formula', 'Visualizar');
      this.visualizar = true;
      return;
    }

    if (this.$route.name == 'formula-revisoes-visualizar') {
      this.visualizar = true;
      this.buscarRevisaoDeFormula();
      return;
    }

    if (this.$route.name == 'formula-revisoes-editar') {
      this.buscarRevisaoDeFormula();
      return;
    }

    if (this.id) {
      helpers.redirecionarSemPermissao(this, 'Formula', 'Editar');
      this.buscar();
      return;
    }

    helpers.redirecionarSemPermissao(this, 'Formula', 'Inserir');
    if (this.$route.query?.idFormulaMensurando) this.buscarDadosFormulaFilha();
    this.$store.dispatch('Layout/alterarTituloPagina', this.tituloFormulario);
    this.indiceAba = 0;
  },
  methods: {
    voltar: function () {
      this.$router.back();
    },
    salvarClickAba() {
      this.salvar('continuar');
    },
    buscarRevisaoDeFormula() {
      this.$store.dispatch('Layout/iniciarCarregamento');

      FormulaService.buscarRevisao(this.id, this.idRevisao)
        .then((res) => {
          this.form = new FormulaModel(res.data);
        })
        .finally(() => {
          this.$refs['dados-formula'].iniciarTabela();
          this.$store.dispatch('Layout/terminarCarregamento');
        });
    },
    buscarDadosFormulaFilha() {
      this.$store.dispatch('Layout/iniciarCarregamento');
      FormulaService.buscar(this.$route.query?.idFormulaMensurando)
        .then((res) => {
          const dadosFormulaPai = {
            formulaPai: { id: res.data.id, nome: res.data.nome },
            unidadeMedida: res.data.unidadeMedida,
            variaveis: res.data.variaveis,
          };
          this.form = new FormulaModel(dadosFormulaPai);
          this.tabela.dados = [...this.form.variaveis].map((el) => {
            return new FormulaTabelaModel(el);
          });
          this.tabelaValida = true;
        })
        .catch(() => {
          this.toastErro(this.$t('modulos.formula.erros.id_invalido'));
        })
        .finally(() => {
          this.$store.dispatch('Layout/terminarCarregamento');
        });
    },
    buscar() {
      this.$store.dispatch('Layout/iniciarCarregamento');
      FormulaService.buscar(this.id)
        .then((res) => {
          const flagPublicada = res.data.flagPublicada;
          const rotaEditar = this.$route.path.includes(
            `/cadastro/formula/${this.id}`
          );
          let resultado = { ...res.data, formulaTexto: this.balancearParenteses(res.data.formulaTexto) }
          this.form = new FormulaModel(resultado);
          if (flagPublicada && rotaEditar) {
            this.confirmar(
              this.$t('geral.titulos.atencao'),
              this.$t('modulos.formula.confirmar_edicao_revisao')
            ).catch(() => {
              this.$router.push({
                name: 'formula',
              });
            });
          }
          this.tabelaValida = true;
        })
        .catch(() => {
          this.toastErro(this.$t('modulos.formula.erros.id_invalido'));
        })
        .finally(() => {
          this.$refs['dados-formula'].iniciarTabela();
          this.$store.dispatch('Layout/terminarCarregamento');
        });
    },
    async confirmacaoSalvar(sequencia) {
      this.$refs['dados-formula']?.podeJustificativaNula();
      await this.$nextTick();
      if (this.id) {
        this.confirmarSalvar().then(() => {
          this.salvar(sequencia);
        });
      } else this.salvar(sequencia);
    },
    salvar(sequencia) {
      this.$refs['dados-formula'].$refs['formula'].validar();
      if (
        !this.$refs['dados-formula'].$refs.form.validate() ||
        !this.$refs['dados-formula'].$refs.formula.ehValido()
      )
        return;
      let parametros = { ...this.form.request, formulaTexto: this.form.formulaTextoComMascara };
      this.$store.dispatch('Layout/iniciarCarregamento');
      FormulaService.salvar(parametros)
        .then((res) => {
          this.toastSucesso(this.$t(`modulos.formula.cadastro_sucesso`));
          if (!this.form.id) {
            this.$router.push({
              name: 'formula-editar',
              params: { id: res.data },
            });
            return;
          } else if (!this.form.id) {
            this.$router.push({ name: 'formula' });
            return;
          }
          if (sequencia == 'sair') {
            this.$router.push({ name: 'formula' });
            return;
          }
          if (sequencia == 'continuar') {
            this.buscar();
            this.$refs['dados-formula'].$refs['formula'].buscarVariaveis();
            const derivadas = this.$refs['formulas-derivadas'];
            derivadas && derivadas.buscarDerivadas();
          }
        })
        .catch((err) => {
          this.toastErro(this.$t(`geral.erros.${err.response.data.errors[0]}`));
        })
        .finally(() => {
          this.$store.dispatch('Layout/terminarCarregamento');
        });
    },
    cancelar() {
      this.confirmarCancelar().then(() => {
        this.$router.push({ name: 'formula' });
      });
    },
    verificarPublicacaoFormula: function () {
      if (this.form.revisoes.length > 1 && !this.form.justificativa) {
        this.indiceAba = 0;
        return this.$refs['dados-formula']?.obrigarPreencherJustificativa();
      }

      this.publicarFormula(this.form.id);
    },
    publicarFormula(id) {
      this.confirmar(
        this.$t('modulos.formula.publicar.titulo'),
        this.$t('modulos.formula.publicar.mensagem')
      ).then(() => {
        if (!this.$refs['dados-formula'].$refs.form.validate()) return;
        this.$store.dispatch('Layout/iniciarCarregamento');
        FormulaService.salvar(this.form.request)
          .then(() => {
            FormulaService.publicar(id)
              .then((res) => {
                this.toastSucesso(
                  this.$t(`modulos.procedimentos_eletronicos.publicar.sucesso`)
                );

                const { incertezas, procedimentosEletronicos } = res.data;

                if (incertezas.length || procedimentosEletronicos.length) {
                  const mensagens = [
                    this.$t(
                      'modulos.formula.alertas.publicado_automaticamente'
                    ),
                    incertezas.length
                      ? `Incertezas: ${incertezas.join(', ')}`
                      : null,
                    procedimentosEletronicos.length
                      ? `Procedimentos Eletrônicos: ${procedimentosEletronicos.join(
                          ', '
                        )}`
                      : null,
                  ]
                    .filter(Boolean)
                    .join('\n');

                  this.confirmar(
                    this.$t('modulos.formula.alertas.titulo_mensagem'),
                    mensagens,
                    false,
                    true,
                    this.$t('geral.botoes.ok'),
                    this.$t('geral.botoes.nao'),
                    { type: null, valor: null, texto: null },
                    false,
                    'custom-white-space-class'
                  ).then(() => {
                    this.$router.push({ name: 'formula' });
                  });
                } else {
                  this.$router.push({ name: 'formula' });
                }
              })
              .finally(() => {
                this.$store.dispatch('Layout/terminarCarregamento');
              });
          })
          .finally(() => {
            this.$store.dispatch('Layout/terminarCarregamento');
          });
      });
    },
    atualizarDadosFormula() {
      this.$refs['dados-formula'].recarregarInputFormula();
    },
    balancearParenteses(str) {
      const match = str.match(/^(\(+)/);
      const quantidadeAbertura = match ? match[0].length : 0;

      let fechamentoRemovidos = 0;
      let i = str.length - 1;

      while (fechamentoRemovidos < quantidadeAbertura && i >= 0) {
        if (str[i] === ')') {
          fechamentoRemovidos++;
          i--;
        } else {
          break;
        }
      }

      return str.substring(0, i + 1);
    },
  },
};
</script>
<style>
.swal-customizado .swal2-html-container {
  white-space: pre-line;
}
</style>
